<template>

  <shell :title="$t('titles.universal_inventory')">

    <v-row class="mb-12">

      <v-col cols="12" sm="9" md="10" xl="11">
        <h2>Log for {{ locationName }}</h2>
      </v-col>

      <v-col cols="12" sm="3" md="2" xl="1" class="text-right">
        <v-btn
          :to="{ name: 'universalInventory', params: { locationID: props.locationID } }"
          prepend-icon="$back"
        >Back</v-btn>
      </v-col>

    </v-row>

    <audit-log-table
      :target-types="['inventory']"
      :locationID="props.locationID"
      :headers="headers"
      :transformer="transformer"
    />

  </shell>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTitle } from '@vueuse/core'

// components
import AuditLogTable from '../../AuditLogTable.vue'
import Shell from '../Shell.vue'

// models
import Location from '../../../models/Location'
import type { FetchAuditLogsResponseRecord } from '../../../models/AuditLog'
import type { VDataTableHeader } from '../../../types/vuetify'

interface Props {
  locationID: number
}

const props = defineProps<Props>()

const { t } = useI18n()
const title = useTitle()
title.value = t('titles.universal_inventory')

const headers: VDataTableHeader[] = [
  {key: 'productName', title: 'Product', sortable: false},
  {key: 'event', title: 'Event', sortable: false},
  {key: 'venue', title: 'Venue', sortable: false},
  {key: 'date', title: 'Date', sortable: false},
  {key: 'spacesTotal', title: 'Inventory', align: 'end', sortable: false},
]

const locationName = computed(() => {
  const location = Location.find(props.locationID)
  return location ? location.locationName : '(unknown)'
})

function transformer(auditLog: FetchAuditLogsResponseRecord) {

  const item = {
    productName: auditLog.actionDetails.product_name,
    event: auditLog.actionDetails.event_name,
    venue: auditLog.actionDetails.venue_name,
    date: auditLog.actionDetails.start_date,
    spacesTotal: auditLog.actionDetails.inventory.spaces_total,
  }

  if (auditLog.actionDetails.end_date !== auditLog.actionDetails.start_date) {
    item.date += ' – ' + auditLog.actionDetails.end_date
  }

  return item

}

</script>
